"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ERROR_NOT_ALLOWED_TRACKING_ORIGIN = exports.ERROR_DOES_NOT_HAVE_ALLOWED_TRACKING_ORIGIN = void 0;
exports.isAllowedTrackingOrigins = isAllowedTrackingOrigins;
const display_1 = require("../tools/display");
const matchOption_1 = require("../tools/matchOption");
const extensionUtils_1 = require("./extension/extensionUtils");
exports.ERROR_DOES_NOT_HAVE_ALLOWED_TRACKING_ORIGIN = 'Running the Browser SDK in a Web extension content script is forbidden unless the `allowedTrackingOrigins` option is provided.';
exports.ERROR_NOT_ALLOWED_TRACKING_ORIGIN = 'SDK initialized on a non-allowed domain.';
function isAllowedTrackingOrigins(configuration, errorStack, windowOrigin = typeof location !== 'undefined' ? location.origin : '') {
    const allowedTrackingOrigins = configuration.allowedTrackingOrigins;
    if (!allowedTrackingOrigins) {
        if ((0, extensionUtils_1.isUnsupportedExtensionEnvironment)(windowOrigin, errorStack)) {
            display_1.display.error(exports.ERROR_DOES_NOT_HAVE_ALLOWED_TRACKING_ORIGIN);
            return false;
        }
        return true;
    }
    const isAllowed = (0, matchOption_1.matchList)(allowedTrackingOrigins, windowOrigin);
    if (!isAllowed) {
        display_1.display.error(exports.ERROR_NOT_ALLOWED_TRACKING_ORIGIN);
    }
    return isAllowed;
}
//# sourceMappingURL=allowedTrackingOrigins.js.map